import { ReactNode, Key } from "react";
import { MenuProps } from "antd";

type MenuItem = Required<MenuProps>["items"][number];

export const createItem = (
  label: ReactNode,
  key: Key,
  icon?: ReactNode,
  children?: MenuItem[],
  // eslint-disable-next-line no-unused-vars
  onClick?: (item: { key: string }) => void
): MenuItem => {
  return {
    label,
    key,
    icon,
    children,
    onClick,
  } as MenuItem;
};
